import { baseInstance } from '@/apis';

const { post: basePost, get: baseGet } = baseInstance;

// 物流相关接口
// 获取物流路线列表
const getTransportPriceCustomQagingQuery = (params) => {
  return baseGet('/laoa-advertisement/advertisement/transport-price-custom/pagingQuery', { params });
};

// 获取物流路线详情
const getTransportPriceCustomGetById = (params) => {
  return baseGet('/laoa-advertisement/advertisement/transport-price-custom/getById', { params });
};

// 获取运价
const getTransportPriceCustomGetPriceInfo = (params) => {
  return basePost('/laoa-advertisement/advertisement/transport-price-custom/getTransportPriceInfo', { params });
};

// 首页查询运价
const getLaoaTransportPriceNationwidePage = (params) => {
  return basePost('/laoa-advertisement/advertisement/gw/laoaTransportPriceNationwidePage', params);
};

// 货源相关接口
// 获取货源信息列表
const getGwWlOrderList = (params) => {
  return basePost('/laoa-advertisement/advertisement/gw/wl/order/list', params);
};

// 获取货源信息详情
const getGwWlOrderDetails = (params) => {
  return basePost('/laoa-advertisement/advertisement/gw/wl/order/orderDetails', params);
};

// 工厂企业相关接口
// 获取工厂企业列表
const getLogisticsList = (params) => {
  return basePost('/laoa-advertisement/advertisement/gw/getLogisticsList', params);
};

// 省市相关接口
// 获取省份列表
const getQueryProv = (params) => {
  return basePost('/laoa-huozhu/api/hz/moduanCommunity/third/queryProv', params);
};
const getQueryCity = (params) => {
  return basePost('/laoa-huozhu/api/hz/moduanCommunity/third/queryCity', params);
};
const getQueryCoun = (params) => {
  return basePost('/laoa-huozhu/api/hz/moduanCommunity/third/queryCoun', params);
};

export {
  getTransportPriceCustomQagingQuery,
  getTransportPriceCustomGetById,
  getTransportPriceCustomGetPriceInfo,
  getLaoaTransportPriceNationwidePage,
  getGwWlOrderList,
  getGwWlOrderDetails,
  getLogisticsList,
  getQueryProv,
  getQueryCity,
  getQueryCoun
};
